var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-app-bar',{attrs:{"dark":"","color":"pink","tile":""}},[_c('v-card-title',[_vm._v("Contraloria")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }